import { UseInfiniteDataQueryTransformers } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQuery.transformers';
import { useInfiniteClassificationTypesList } from '../../../services/modules/classificationTypes/classificationTypes.queries';
import { ClassificationTypeEntityEnum } from '../../classifications/classification.types';
import { CatalogSortTarget } from '../catalog.types';

export const useCatalogSortClassificationTypeOptions = (
  initialSortTarget: CatalogSortTarget | null,
) => {
  const infiniteQuery = useInfiniteClassificationTypesList({
    entity: ClassificationTypeEntityEnum.PRODUCT_COLOR,
    useAsFilter: true,
  });

  const list =
    UseInfiniteDataQueryTransformers.toInfinityListManagerWithoutCheckboxAndCustomParams(
      infiniteQuery,
    );

  const items: CatalogSortTarget[] = list.state.items.map(
    (item: { id: string; name: string; code: string }) => ({
      id: item.id,
      name: item.name,
      code: item.code,
    }),
  );

  const isInitialSortTargetMissing =
    !!initialSortTarget && !items.some((option) => option.id === initialSortTarget.id);

  const options = isInitialSortTargetMissing ? [initialSortTarget, ...items] : items;

  return {
    options,
    isLoading: list.state.isLoadingPage || list.state.isLoadingMore,
    hasNextPage: list.state.hasMore,
    loadMoreRows: list.loadMoreRows,
  };
};
